const sucursalesData3 = [
  {
     nombre: "Blue Room - La Rioja",
    direccion: "Plaza Comercial Omnia, Carretera Nacional KM 267, Villas del Uro, Monterrey, N.L.",
    telefono: "+52 8116-6187-00",
    correo: "larioja@blueroom.mx",
    fachada: "https://cdn.shopify.com/s/files/1/0248/0203/3746/files/la_rioja.png?v=1736463375",
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.4262258854546!2d-100.23675152515082!3d25.55748271701468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8662c774a2d50cd7%3A0x742abe161734b3fb!2sBlue%20Room%20La%20Rioja!5e0!3m2!1ses!2smx!4v1736532131393!5m2!1ses!2smx"
    },
  {
    nombre: "Blue Room - Calzada del Valle",
    direccion: "Calzada del Valle, Calzada del Valle, Pte. 509, Del Valle, 66220 San Pedro Garza García, N.L.",
    telefono: "+52 8116-0002-95",
    correo: "valle@blueroom.mx",
    fachada: "https://cdn.shopify.com/s/files/1/0248/0203/3746/files/valle.png?v=1736463375",
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1664.8666574138615!2d-100.38370090500045!3d25.660992349986035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8662bdff702ffc75%3A0xdc466a7bb6ffae14!2sBlue%20Room%20Calzada%20del%20Valle!5e0!3m2!1ses!2smx!4v1736532016039!5m2!1ses!2smx"
  },
  {
    nombre: "Blue Room - Cumbres Elite",
    direccion: "Paseo de los Leones 1001-local 101 a, Cumbres Madeira, 64349 Monterrey, N.L., México",
    telefono: "+52 8119-1112-30",
    correo: "cumbreselite@blueroom.mx",
    fachada: "https://cdn.shopify.com/s/files/1/0248/0203/3746/files/cumbres.png?v=1736463375",
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.86833376906!2d-100.41189482514471!3d25.741867409425364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8662971e05592f1d%3A0x7482aea5ffa7fcf6!2sBlue%20Room%20Cumbres%20Elite!5e0!3m2!1ses!2smx!4v1736532081826!5m2!1ses!2smx"
  },
  {
        nombre: "Blue Room - Barragan",
    direccion: "Av Manuel L. Barragan 1400, Las Misiones, C.P 66428, San Nicolas, Mexico",
    telefono: "+52 8180-8888-14",
    correo: "barragan@blueroom.mx",
    fachada: "https://cdn.shopify.com/s/files/1/0248/0203/3746/files/barragan.png?v=1736463375",
     mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.2112750355036!2d-100.30719932514404!3d25.76358420852836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86629480ab30a16b%3A0xadac587ec5daa17a!2sAv.%20Manuel%20L.%20Barrag%C3%A1n%201400%2C%20Las%20Misiones%2C%2066428%20San%20Nicol%C3%A1s%2C%20N.L.!5e0!3m2!1ses!2smx!4v1736531234806!5m2!1ses!2smx"
  },
  {
    nombre: "Blue Room - Leones",
    direccion: "Av Paseo de los Leones 1209, Cumbres 1º Sector, 64610 Monterrey, N.L., México",
    telefono: "+52 8116-3636-95",
    correo: "leones@blueroom.mx",
    fachada: "https://cdn.shopify.com/s/files/1/0248/0203/3746/files/leones.png?v=1736463375",
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3595.2156635155266!2d-100.35841992514622!3d25.697282611265006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86629673614d852b%3A0x1c090a872402842b!2sBlue%20Room%20Leones!5e0!3m2!1ses!2smx!4v1736532176718!5m2!1ses!2smx"
  },
  {
    nombre: "Blue Room - Prol. Madero",
    direccion: "Prol Madero 4064, Fierro, Monterrey, N.L., México",
    telefono: "+52 8116-0020-04",
    correo: "maleman@blueroom.mx",
    fachada: "https://cdn.shopify.com/s/files/1/0248/0203/3746/files/madero.png?v=1736463375",
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3595.5909972574705!2d-100.27349412514663!3d25.684849511777514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86629550a670f2cf%3A0x9070caae4ec97278!2sBlue%20Room%20Suc.%20Madero!5e0!3m2!1ses!2smx!4v1736532226753!5m2!1ses!2smx"
  },
  {
    nombre: "Blue Room - Saltillo",
    direccion: "Blvd. Nazario Ortiz 2598, Sin Nombre de Col 16, Saltillo, Coah., México",
    telefono: "+52 8115-5682-50",
    correo: "saltillo@blueroom.mx",
    fachada: "https://cdn.shopify.com/s/files/1/0248/0203/3746/files/saltillo.png?v=17364633757",
    mapa: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3602.398646405799!2d-100.98006352515405!3d25.45836082107404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86886d6c871b3c19%3A0xf716a4e06b164253!2sBlue%20Room!5e0!3m2!1ses!2smx!4v1736532273656!5m2!1ses!2smx"
  }
];

// Seleccionamos los elementos DOM
const sucursalElements3 = document.querySelectorAll('.sucursal');
const direccionElement3 = document.getElementById('direccion');
const telefonoElement3 = document.getElementById('telefono');
const correoElement3 = document.getElementById('correo');
const fachadaElement3 = document.getElementById('fachada');
const mapaElement3 = document.getElementById('mapa');

// Inicializar el mapa con la sucursal 1 por defecto
const inicializarSucursal3 = sucursalesData3[0]; // Sucursal 1
direccionElement.textContent = `Dirección: ${inicializarSucursal3.direccion}`;
telefonoElement.innerHTML = `<i class="fas fa-phone-alt"></i> Teléfono: ${inicializarSucursal3.telefono}`;
correoElement.innerHTML = `<i class="fas fa-envelope"></i> Correo: ${inicializarSucursal3.correo}`;
fachadaElement.src = inicializarSucursal3.fachada;
mapaElement.src = inicializarSucursal3.mapa; // Mapa por defecto de la Sucursal 1

// Cambiar el contenido dinámicamente cuando se pase el mouse sobre las sucursales
sucursalElements.forEach(sucursal => {
  sucursal.addEventListener('mouseover', (event) => {
    const sucursalIndex3 = event.target.dataset.sucursal - 1;
    const sucursalData3 = sucursalesData3[sucursalIndex];

    // Cambiar los valores de dirección, teléfono, correo, fachada y mapa
    direccionElement.textContent = `Dirección: ${sucursalData3.direccion}`;
    telefonoElement.innerHTML = `<i class="fas fa-phone-alt"></i> Teléfono: ${sucursalData3.telefono}`;
    correoElement.innerHTML = `<i class="fas fa-envelope"></i> Correo: ${sucursalData3.correo}`;
    fachadaElement.src = sucursalData3.fachada;
    mapaElement.src = sucursalData3.mapa; // Actualizar mapa según la sucursal
  });
});
